module.exports = __webpack_public_path__ + "static/media/2030093000.8efb5f8c.jpg";